import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48383074"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 2 }
const _hoisted_2 = { class: "flex justify-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "statistic" }
const _hoisted_5 = { class: "statistic__item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "statistic__title" }, "id", -1))
const _hoisted_7 = { class: "statistic__text" }
const _hoisted_8 = { class: "statistic__item" }
const _hoisted_9 = { class: "statistic__title" }
const _hoisted_10 = { class: "statistic__text" }
const _hoisted_11 = { class: "statistic__item" }
const _hoisted_12 = { class: "statistic__title" }
const _hoisted_13 = { class: "statistic__text" }
const _hoisted_14 = { class: "statistic__item" }
const _hoisted_15 = { class: "statistic__title" }
const _hoisted_16 = { class: "statistic__text" }
const _hoisted_17 = { class: "statistic__item" }
const _hoisted_18 = { class: "statistic__title" }
const _hoisted_19 = { class: "statistic__text" }
const _hoisted_20 = {
  key: 0,
  style: {"margin-top":"30px"},
  class: "promo__item"
}
const _hoisted_21 = { style: {"margin-top":"0","color":"white"} }
const _hoisted_22 = { style: {"font-size":"18px"} }
const _hoisted_23 = { class: "landings" }
const _hoisted_24 = { class: "landings__top" }
const _hoisted_25 = { class: "landings__title" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "landings__divider" }, null, -1))
const _hoisted_27 = { class: "landings__btn-wrapper" }
const _hoisted_28 = { class: "promo__list" }
const _hoisted_29 = { class: "promo__title" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_958_619)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.59366 8.11328C1.66653 8.23919 1.76312 8.39965 1.88278 8.58493C2.19013 9.06082 2.64528 9.69368 3.2362 10.324C4.43018 11.5976 6.09951 12.7799 8.1665 12.7799C10.2335 12.7799 11.9028 11.5976 13.0968 10.324C13.6877 9.69368 14.1429 9.06082 14.4502 8.58493C14.5699 8.39965 14.6665 8.23919 14.7393 8.11328C14.6665 7.98737 14.5699 7.82691 14.4502 7.64163C14.1429 7.16574 13.6877 6.53288 13.0968 5.90258C11.9028 4.62899 10.2335 3.44661 8.1665 3.44661C6.09951 3.44661 4.43018 4.62899 3.2362 5.90258C2.64528 6.53288 2.19013 7.16574 1.88278 7.64163C1.76312 7.82691 1.66653 7.98737 1.59366 8.11328ZM15.4998 8.11328C16.0961 7.81514 16.096 7.81491 16.0959 7.81467L16.0948 7.81253L16.0925 7.80797L16.0849 7.79316C16.0786 7.7808 16.0696 7.76349 16.058 7.74157C16.0348 7.69775 16.0012 7.63543 15.9572 7.55727C15.8693 7.40104 15.7399 7.18096 15.5703 6.91826C15.2318 6.39416 14.7286 5.69368 14.0695 4.99065C12.7635 3.59757 10.7662 2.11328 8.1665 2.11328C5.56683 2.11328 3.56949 3.59757 2.26348 4.99065C1.60439 5.69368 1.10121 6.39416 0.762728 6.91826C0.593071 7.18096 0.463698 7.40104 0.375818 7.55727C0.331853 7.63543 0.298197 7.69775 0.275006 7.74157C0.263408 7.76349 0.254421 7.7808 0.248063 7.79316L0.240497 7.80797L0.238197 7.81253L0.237417 7.81408C0.237295 7.81432 0.236886 7.81514 0.833171 8.11328L0.236886 7.81514C0.143043 8.00282 0.143043 8.22374 0.236886 8.41142L0.833171 8.11328C0.236886 8.41142 0.236763 8.41118 0.236886 8.41142L0.238197 8.41404L0.240497 8.41859L0.248063 8.4334C0.254421 8.44577 0.263408 8.46307 0.275006 8.48499C0.298197 8.52882 0.331853 8.59113 0.375818 8.66929C0.463698 8.82552 0.593071 9.0456 0.762728 9.3083C1.10121 9.83241 1.60439 10.5329 2.26348 11.2359C3.56949 12.629 5.56683 14.1133 8.1665 14.1133C10.7662 14.1133 12.7635 12.629 14.0695 11.2359C14.7286 10.5329 15.2318 9.83241 15.5703 9.3083C15.7399 9.0456 15.8693 8.82552 15.9572 8.66929C16.0012 8.59113 16.0348 8.52882 16.058 8.48499C16.0696 8.46307 16.0786 8.44577 16.0849 8.4334L16.0925 8.41859L16.0948 8.41404L16.0956 8.41248C16.0957 8.41224 16.0961 8.41142 15.4998 8.11328ZM15.4998 8.11328L16.0961 8.41142C16.19 8.22374 16.1897 8.00235 16.0959 7.81467L15.4998 8.11328Z",
      fill: "#EDB94A"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.16667 6.77865C7.43029 6.77865 6.83333 7.3756 6.83333 8.11198C6.83333 8.84836 7.43029 9.44531 8.16667 9.44531C8.90305 9.44531 9.5 8.84836 9.5 8.11198C9.5 7.3756 8.90305 6.77865 8.16667 6.77865ZM5.5 8.11198C5.5 6.63922 6.69391 5.44531 8.16667 5.44531C9.63943 5.44531 10.8333 6.63922 10.8333 8.11198C10.8333 9.58474 9.63943 10.7786 8.16667 10.7786C6.69391 10.7786 5.5 9.58474 5.5 8.11198Z",
      fill: "#EDB94A"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_958_619" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(0.166504 0.113281)"
      })
    ])
  ])
], -1))
const _hoisted_32 = { class: "promo__show-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleDivider = _resolveComponent("TitleDivider")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_center = _resolveComponent("center")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, {
    style: {"background-color":"#151a27","padding-left":"16px","padding-right":"16px"},
    class: "offers-page"
  }, {
    default: _withCtx(() => [
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_TitleDivider, {
            key: 0,
            title: _ctx.offer.name
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_btn, {
        "no-caps": "",
        icon: "chevron_left",
        flat: "",
        label: _ctx.$t('pages.offers.offers'),
        class: "q-mb-lg",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/offers')))
      }, null, 8, ["label"]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_center, {
            key: 1,
            class: "q-mt-lg"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_spinner, {
                color: "primary",
                size: "3em",
                thickness: 2
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                style: {"max-width":"300px","width":"100%","margin-bottom":"64px"},
                src: `${_ctx.storageUrl + '/' + _ctx.offer.image}`
              }, null, 8, _hoisted_3)
            ]),
            _createElementVNode("ul", _hoisted_4, [
              _createElementVNode("li", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.offer.id), 1)
              ]),
              _createElementVNode("li", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('pages.offers.type')), 1),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.offer.trafficSources
                .reduce((prev, el) => {
                  return [...prev, el.name]
                }, [])
                .join(', ')), 1)
              ]),
              _createElementVNode("li", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('pages.offers.vertical')), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.verticals[_ctx.offer.vertical]), 1)
              ]),
              _createElementVNode("li", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('pages.offers.geo')), 1),
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.statistic.geo), 1)
              ]),
              _createElementVNode("li", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('pages.offers.condition')), 1),
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.statistic.type), 1)
              ])
            ]),
            (_ctx.offer.description)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("h4", _hoisted_21, _toDisplayString(_ctx.$t('offer.description')), 1),
                  _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.offer.description), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("h5", _hoisted_25, _toDisplayString(_ctx.$t('pages.offers.landing')), 1),
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  (
                _ctx.isMB ||
                  _ctx.hasAccess(_ctx.offer.offersAccess && _ctx.offer.offersAccess.status)
              )
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        "no-caps": "",
                        class: "landings__btn",
                        icon: "add",
                        label: _ctx.$t('pages.offers.createCampaighn'),
                        color: "primary",
                        "text-color": "dark",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (
                _ctx.isMB
                  ? _ctx.$router.push('/campaigns/new')
                  : _ctx.$router.push(`/campaigns?offerId=${_ctx.offer.id}`)
              ), ["stop"]))
                      }, null, 8, ["label"]))
                    : (_openBlock(), _createBlock(_component_q_btn, {
                        key: 1,
                        "no-caps": "",
                        color: "primary",
                        "text-color": "dark",
                        class: "landings__btn",
                        disable: !!_ctx.offer.offersAccess,
                        label: 
                _ctx.offer.offersAccess
                  ? _ctx.$t('pages.offers.asked')
                  : _ctx.$t('pages.offers.ask')
              ,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getAccess()))
                      }, null, 8, ["disable", "label"]))
                ])
              ]),
              _createElementVNode("ul", _hoisted_28, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promos, (promo, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "promo__item",
                    key: index
                  }, [
                    _createElementVNode("h6", _hoisted_29, _toDisplayString(promo.name), 1),
                    _createElementVNode("div", {
                      onClick: ($event: any) => (_ctx.landingRedirect(promo.url)),
                      class: "promo__show"
                    }, [
                      _hoisted_31,
                      _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('pages.offers.look')), 1)
                    ], 8, _hoisted_30)
                  ]))
                }), 128))
              ])
            ])
          ]))
    ]),
    _: 1
  }))
}